export default "__VITE_ASSET__Bp17yksM__"